import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import {Clear, Refresh, VisibilityOff, Visibility, Edit, EditOff} from '@mui/icons-material'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Dialog from 'components/Dialog'
import PhoneFieldConfig from 'components/PhoneFieldConfig'
import NumberFieldConfig from 'components/NumberFieldConfig'
import FormulaFieldConfig from 'components/FormulaFieldConfig'
import DateFieldConfig from 'components/DateFieldConfig'
import LinkedFieldConfig from 'components/LinkedFieldConfig'
import LookupFieldConfig from 'components/LookupFieldConfig'
import Confirmation from 'components/Confirmation'
import Alert from 'components/Alert'
import SetDefault from './SetDefault'
import {
    fetchDeleteCol,
    changeTypeToBasic,
    changeTypeToComplex,
    setDefaultValue
} from 'modules/entities/actions'
import {
    toggleFieldSort,
    toggleFieldHide,
    fetchLockCol,
	toggleReadonly
} from 'modules/collection/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import {icons} from 'utils/enums/icons'
import {getRelatedFieldsForField, getDefaultOptions, getFieldDefaultValue} from 'utils/utils'

const Actions = styled.div`
    display: flex;
    margin-top: auto;
    margin-bottom: 10px;
    justify-content: space-between;
`

const Divider = styled.div`
    border-right: 1px solid #e1ecef;
    margin: 0 20px 0 auto;
    height: 45px;
`

const IconButton = styled.button`
    background-color: transparent;
    color: ${props => props.active ? '#415dd4' : '#a0b7be'};
    font-size: 10px;
    width: 60px;
    height: 45px;
    padding: 0;
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    pointer-events: ${props => !props.active && props.connection ? 'none' : 'auto'};
    cursor: ${props => !props.active && props.connection ? 'auto' : 'pointer'};
    opacity: ${props => !props.active && props.connection ? '0.5' : '1'};

    i {
        font-size: 28px;
    }
`

class TableTop extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            openDialog: null,
            openFieldConfig: null,
            type: null
        }
    }

    handleOpenDialog = (action, type) => {
        this.setState({ openDialog: action, type })
    }

    handleCloseDialog = () => {
        this.setState({ openDialog: null, type: null })
    }

    handleDelete = () => {
        this.props.fetchDeleteCol(this.props.targetCol)
        this.props.handleCloseMenu()
        this.handleCloseDialog()
    }

    handleConfirm = () => {
        this.setState({ openDialog: null }, () => this.changeType(this.state.type))
    }

    changeType = (type) => {
        if (type === fieldtype.image || type === fieldtype.text || type === fieldtype.email ||
            type === fieldtype.textarea || type === fieldtype.check || type === fieldtype.url) {
            this.props.changeTypeToBasic(this.props.targetCol, type)
            this.props.handleCloseMenu()
            this.setState({ type: null })
        } else if (this.props.entitiesCount === 1 && type === fieldtype.linkedfield) {
            this.props.changeTypeToComplex(this.props.targetCol, {main: {singular: this.props.fieldName}}, fieldtype.linkedfield)
            this.props.handleCloseMenu()
            this.setState({ type: null })
        } else {
            this.setState({ openFieldConfig: type })
        }
    }

    changeTypeToComplex = (config) => {
        this.props.changeTypeToComplex(this.props.targetCol, config, this.state.openFieldConfig)
    }

    handleCloseConfig = () => {
        this.setState({ openFieldConfig: null, type: null })
    }

    toggleFieldSort = () => {
        this.props.toggleFieldSort(this.props.targetCol)
        this.props.handleCloseMenu()
    }

    toggleFieldHide = () => {
        this.props.toggleFieldHide(this.props.targetCol)
        this.props.handleCloseMenu()
    }

    fetchLockCol = () => {
        this.props.fetchLockCol(this.props.targetCol)
        this.props.handleCloseMenu()
    }

    handleSave = (field, value) => {
        this.props.setDefaultValue(field, value)
        this.props.handleCloseMenu()
    }

	toggleReadonly = () => {
        this.props.toggleReadonly(this.props.targetCol)
        this.props.handleCloseMenu()
    }

    render() {
        const { intl, targetCol, permissions, connection } = this.props
        const fields = getRelatedFieldsForField(targetCol)
        const options = getDefaultOptions(targetCol)
        const pathId = getFieldDefaultValue(targetCol)

        return (
            <React.Fragment>
                <Actions>
                    {permissions.Designer && Object.keys(fieldtype).map((item, index) =>
                        fieldtype[item] !== fieldtype.pointer &&
                        <IconButton
                            onClick={() => fields.length && this.props.type !== fieldtype[item] ?
                                this.handleOpenDialog('change', fieldtype[item]) :
                                this.changeType(fieldtype[item])
                            }
                            active={this.props.type === fieldtype[item]}
                            key={index}
                            connection={connection}
                        >
                            <i className={icons[item]} />
                            {intl.formatMessage({id: `table.field_${item}`})}
                        </IconButton>
                    )}
                    <Divider />
                    {permissions.Designer && !!options.length &&
                        <IconButton active={!!pathId} onClick={() => this.handleOpenDialog('default')}>
                            <Refresh />
                            {pathId ?
                                intl.formatMessage({id: "table.edit_default"}) :
                                intl.formatMessage({id: "table.set_default"})
                            }
                        </IconButton>
                    }
                    {!this.props.documentPage &&
                        <React.Fragment>
                            {permissions.Designer && !this.props.hiddenField &&
								<IconButton active={this.props.activeLock} onClick={this.fetchLockCol}>
									<i className='flicon-lock' />
									{this.props.activeLock ?
										intl.formatMessage({id: "table.unlock"}) :
										intl.formatMessage({id: "table.lock"})
									}
								</IconButton>
							}
                            <IconButton active={this.props.sorting} onClick={this.toggleFieldSort}>
                                {this.props.sorting ?
                                <React.Fragment>
                                    {this.props.sorting.type === 1 ?
                                        <React.Fragment>
                                            <i className='flicon-sort'/>
                                            {intl.formatMessage({id: "table.sort_asc"})}
                                        </React.Fragment> :
                                        <React.Fragment>
                                            <i className='flicon-sort-alt'/>
                                            {intl.formatMessage({id: "table.sort_desc"})}
                                        </React.Fragment>}
                                </React.Fragment> :
                                <React.Fragment>
                                    <i className='flicon-sort'/>
                                    {intl.formatMessage({id: "table.sort"})}
                                </React.Fragment>
                            }
                            </IconButton>
                            {permissions.Designer && !this.props.globalView && !this.props.activeLock &&
								<IconButton onClick={this.toggleFieldHide} active={this.props.hiddenField}>
									{this.props.hiddenField ?
										<React.Fragment>
											<Visibility sx={{fontSize: '28px'}} />
											{intl.formatMessage({id: "table.show"})}
										</React.Fragment> :
										<React.Fragment>
											<VisibilityOff sx={{fontSize: '28px'}} />
											{intl.formatMessage({id: "table.hide"})}
										</React.Fragment>
									}
								</IconButton>
                        	}
							{permissions.Designer && !this.props.globalView &&
								<IconButton onClick={this.toggleReadonly} active={this.props.readonlyField}>
									<EditOff sx={{fontSize: '28px'}} />
									{intl.formatMessage({id: "table.readonly"})}
								</IconButton>
                        	}
                        </React.Fragment>
                    }
                    {permissions.Designer && !connection &&
						<IconButton onClick={() => this.handleOpenDialog('delete')}>
							<i className='flicon-trashbin'/>
							{intl.formatMessage({id: "table.remove"})}
						</IconButton>
					}
                    <IconButton onClick={this.props.handleCloseMenu}>
                        <Clear sx={{margin: 'auto'}} />
                    </IconButton>
                </Actions>
                <Dialog
                    open={!!this.state.openDialog}
                    onClose={this.handleCloseDialog}
                >
                    {this.state.openDialog === 'default' &&
                        <SetDefault
                            options={options}
                            fieldId={targetCol}
                            handleClose={this.handleCloseDialog}
                            handleSave={this.handleSave}
                            pathId={pathId}
                        />
                    }
                    {this.state.openDialog === 'delete' &&
                        <Confirmation
                            text={intl.formatMessage({id: "table.confirm_delete_field_text"}, {
                                name: this.props.fieldName})}
                            handleClose={this.handleCloseDialog}
                            handleConfirm={this.handleDelete}
                        >
                            {!!fields.length &&
                                <Alert text={intl.formatMessage({id: "table.confirm_delete_related_field_text"}, {
                                    name: this.props.fieldName})}
                                >
                                    <ul style={{paddingLeft: '65px'}}>
                                        {fields.map((item, index) =>
                                            <li key={index}>{item}</li>
                                        )}
                                    </ul>
                                </Alert>
                            }
                        </Confirmation>
                    }
                    {this.state.openDialog === 'change' &&
                        <React.Fragment>
                            <DialogTitle>
                                {intl.formatMessage({id: "table.confirm_change_title"})}
                            </DialogTitle>
                            <DialogContent>
                                <Alert text={intl.formatMessage({id: "table.confirm_change_related_field_text"}, {
                                    name: this.props.fieldName})}
                                >
                                    <ul style={{paddingLeft: '65px'}}>
                                        {fields.map((item, index) =>
                                            <li key={index}>{item}</li>
                                        )}
                                    </ul>
                                </Alert>
                                <DialogContentText>
                                    {intl.formatMessage({id: "table.confirm_promote_field_text"}, {
                                        name: this.props.fieldName})}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleCloseDialog} color="primary">
                                    {intl.formatMessage({id: "app.confirm_cancel"})}
                                </Button>
                                <Button onClick={this.handleConfirm} variant="contained" color="secondary">
                                    {intl.formatMessage({id: "table.confirm_promote"})}
                                </Button>
                            </DialogActions>
                        </React.Fragment>
                    }
                </Dialog>
                <Dialog
                    fullWidth={true}
                    open={Boolean(this.state.openFieldConfig)}
                    onClose={this.handleCloseConfig}
                    PaperProps={{sx: {overflowY: 'visible'}}}
                >
                    {this.state.openFieldConfig === fieldtype.phone ?
                        <PhoneFieldConfig
                            onClose={this.handleCloseConfig}
                            config={this.props.type === fieldtype.phone ? this.props.config : {}}
                            changeTypeToPhone={this.changeTypeToComplex}
                            handleCloseMenu={this.props.handleCloseMenu}
                        /> : this.state.openFieldConfig === fieldtype.number ?
                        <NumberFieldConfig
                            onClose={this.handleCloseConfig}
                            config={this.props.type === fieldtype.number ? this.props.config : {}}
                            changeTypeToNumber={this.changeTypeToComplex}
                            handleCloseMenu={this.props.handleCloseMenu}
                        /> : this.state.openFieldConfig === fieldtype.datetime ?
                        <DateFieldConfig
                            onClose={this.handleCloseConfig}
                            config={this.props.type === fieldtype.datetime ? this.props.config : {}}
                            changeTypeToDate={this.changeTypeToComplex}
                            handleCloseMenu={this.props.handleCloseMenu}
                            entity={this.props.entity}
                            targetCol={targetCol}
                        /> : this.state.openFieldConfig === fieldtype.linkedfield ?
                        <LinkedFieldConfig
							originEntity={this.props.entity}
                            onClose={this.handleCloseConfig}
                            changeTypeToLinked={this.changeTypeToComplex}
                            config={this.props.type === fieldtype.linkedfield ? this.props.config : {}}
                            fieldName={this.props.fieldName}
                            handleCloseMenu={this.props.handleCloseMenu}
                            foreignerEcn={this.props.type === fieldtype.lookup ?
                                undefined : this.props.foreignerEcn}
                            linkedTemplate={this.props.type === fieldtype.lookup ?
                                undefined : this.props.linkedTemplate}
                            foreignerFcns={this.props.type === fieldtype.lookup ?
                                undefined : this.props.foreignerFcns}
                        /> : this.state.openFieldConfig === fieldtype.lookup ?
                        <LookupFieldConfig
                            onClose={this.handleCloseConfig}
                            changeTypeToLookup={this.changeTypeToComplex}
                            handleCloseMenu={this.props.handleCloseMenu}
                            foreignerFcn={this.props.type === fieldtype.linkedfield ?
                                undefined : this.props.foreignerFcns[0]}
                            relation={this.props.type === fieldtype.linkedfield ? undefined :
                                this.props.relation ? this.props.relation.join('-') : this.props.relation}
                            entity={this.props.entity}
                            fieldId={targetCol}
                            linkedTemplate={this.props.type === fieldtype.linkedfield ?
                                undefined : this.props.linkedTemplate}
                        /> : this.state.openFieldConfig === fieldtype.formula ?
                        <FormulaFieldConfig
                            fieldId={targetCol}
                            onClose={this.handleCloseConfig}
                            entity={this.props.entity}
                            config={this.props.type === fieldtype.formula ? this.props.config : {}}
                            changeTypeToFormula={this.changeTypeToComplex}
                            handleCloseMenu={this.props.handleCloseMenu}
                        />
                        : <div />
                    }
                </Dialog>
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({login}) => ({
    permissions: login.permissions
})

export default connect(mapStateToProps, {
    fetchDeleteCol,
    changeTypeToBasic,
    changeTypeToComplex,
    toggleFieldSort,
    toggleFieldHide,
    fetchLockCol,
    setDefaultValue,
	toggleReadonly
})(injectIntl(TableTop))
